import { Box } from '@mui/material';

import { url } from '../../appRouter/url';
import { EasyBreadcrumbs, type EasyBreadcrumbsItem } from '../../components/general';
import { usePageTitle } from '../../hooks/usePageTitle';
import { DatenschutzContent } from './DatenschutzContent';

export const DatenschutzPage = () => {
  usePageTitle('Datenschutz');
  const breadcrumbs: EasyBreadcrumbsItem[] = [
    {
      href: url.root(),
      label: 'Dashboard',
    },
    {
      href: '',
      label: 'Datenschutz',
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        gap: 2,
        paddingY: 2,
        boxSizing: 'border-box',
      }}
    >
      <EasyBreadcrumbs items={breadcrumbs} />
      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: 'auto' }}>
        <DatenschutzContent />
      </Box>
    </Box>
  );
};
